const url = {
  global: {},
  efunapi: {
    url: 'efunapi.php',
    method: {
      login: 'EFUNAPI_LOGIN',
      getlist: 'EFUNAPI_GETCOURSE',
      getclasslist: 'EFUNAPI_GETCLASS',
      getclasshourbyid: 'EFUNAPI_GETCLASSHOURBYCLASSID',
      getclasshourreport: 'EFUNAPI_GETTEACOMMENT',
      yijianqingjia: 'EFUNAPI_LEAVECLASSHOUR',
      saveremark: 'EFUNAPI_ADDCLASSHOURNOTICE',
      getqjloglist: 'EFUNAPI_GETLEAVELOGBYCID',
      rebackqjlog: 'EFUNAPI_REVOKELEAVE',
      saveplsettime: 'EFUNAPI_UPDATECLASSHOURMORE',
      saveclasshourtime: 'EFUNAPI_UPDATECLASSHOUR',
      schtealist: 'EFUNAPI_GETUSERSHORT',
      updateclasstea: 'EFUNAPI_UPDATECLASSTEACHER',
      schstulist: 'EFUNAPI_GETUSERSHORT',
      updateclassstu: 'EFUNAPI_UPDATECLASSSTUDENTS',
      schcourselist: 'EFUNAPI_GETCOURSE',
      updataclasscourse: 'EFUNAPI_UPDATECLASSCOURSE',
      getlevellist: 'EFUNAPI_GETLEVELLIST',
      getcourselist: 'EFUNAPI_GETCOURSE',
      updataclass: 'EFUNAPI_UPDATECLASS',
      stopclass: 'EFUNAPI_STOPCLASS',
      delclass: 'EFUNAPI_DELCLASS',
      getlevelist: 'EFUNAPI_GETLEVELLIST',
      editclasslevel: 'EFUNAPI_UPDATELEVEL',
      addclasslevel: 'EFUNAPI_ADDLEVEL',
      dellevel: 'EFUNAPI_DELLEVEL',
      getcoursebylevel: 'EFUNAPI_GETRELATIONCOURSE',
      editgllevelcourse: 'EFUNAPI_UPDATERELATIONCOURSE',
      addgllevelcourse: 'EFUNAPI_RELATIONCOURSEONE',
      delgllevelcourse: 'EFUNAPI_DELRELATIONCOURSE',
      getuserlist: 'EFUNAPI_GETUSER',
      adduser: 'EFUNAPI_ADDUSER',
      edituser: 'EFUNAPI_UPDATEUSER',
      deluser: 'EFUNAPI_DELUSER',
      enableuser: 'EFUNAPI_ENABLEUSER',
      getrolelist: 'EFUNAPI_GETROLE',
      getwxuserlist: 'EFUNAPI_GETWECHATLIST',
      getclassbyusername: 'EFUNAPI_GETCLASSBYUSERORPHONE',
      getclasshourcount: 'EFUNAPI_GETCLASSHOURSTATISTICS',
      getusercountdata: 'EFUNAPI_GETUSERCOUNT',
      getclasscountdata: 'EFUNAPI_GETCLASSCOUNT',
      getclasshourmoneycount: 'EFUNAPI_GETCLASSHOURSTATISTICS',
      getpinbanlist: 'EFUNAPI_GETSPELLCLASSLIST',
      getclasshourlist: 'EFUNAPI_GETCLASSHOUR',
      getuserremark: 'EFUNAPI_GETUSERREMARK',
      delremark: 'EFUNAPI_DELUSERREMARK',
      addremark: 'EFUNAPI_ADDUSERREMARK',
      getpricezerolist: 'EFUNAPI_GETPRICEZERO',
      getteamonthpricedata: 'EFUNAPI_GETTEACHERMONTHPRICE',
      editteaprice: 'EFUNAPI_UPDATETEAPRICE',
      exportteacherprice: 'EFUNAPI_EXPORTTEACHERPRICE',
      exportteacherfree: 'EFUNAPI_EXPORTTEACHERFREETIME',
      exportlevellogdata: 'EFUNAPI_EXPORTLEAVELOG',
      getmanagerhourdata: 'EFUNAPI_GETCLASSHOURMANAGERMONTH',
      getonedayclasshourdata: 'EFUNAPI_GETONEDAYCLASSHOUR',
      exportlevellistdata: 'EFUNAPI_GETLEVELCOURSELIST',
      addcourse: 'EFUNAPI_ADDCOURSE',
      editcourse: 'EFUNAPI_UPDATECOURSE',
      addclass: 'EFUNAPI_ADDCLASSNEW',
      getclassbyuserid: 'EFUNAPI_GETCLASSBYUSERID',
      gethomeworkbychid: 'EFUNAPI_GETSTUDENTWORKBYCHID',
      saveclasshourremark: 'EFUNAPI_ADDCLASSHOURTEANOTICE',
      getpinlog: 'EFUNAPI_GETSPELLCOMMENT',
      savepinremark: 'EFUNAPI_ADDSPELLCOMMENT',
      updatepinclassinfo: 'EFUNAPI_UPDATESPELLCLASS',
      selecttealist: 'EFUNAPI_GETTEASHORT',
      updatatimemodelbyclass: 'EFUNAPI_UPDATETIMEMODEL',
      getfreetealist: 'EFUNAPI_GETFREETIMETEACHER',
    },
  },
};

const CommonConfig = {
  CommonParams: {
    appId: 'f4ac0b61c74036ecf7528203f0ec7554', // 客户端编号
    clienttype: 'WEB',
  },
  imageHost: 'http://ogmy9qmgf.bkt.clouddn.com/image/',
};

const key = {
  // client param
  des_client_key: 'aGllbmdsaXNoZnVu', // 16
  des_client_iv: 'aGllZnVu', // 8

  aes_server_key: 'aGVsbG9lbmdsaXNo', // 16
  aes_server_iv: 'bG9lbmdsaXNoZnVu', // 16

  // localstorage
  aes_local_key: 'ZW5nbGlzaGZ1bmhl',
  aes_local_iv: 'bGlzaGZ1bmhlbGxv',
};

const host = process.env.API_HOST || 'https://orbit-x-edu.us/';

// eslint-disable-next-line no-unused-vars
const DevConfig = {
  isDev: true,
  host: host + 'api/',
  jhost: host,
  url,
  key,
  ...CommonConfig,
};

export default DevConfig;
// export default ProductConfig;
